package ir.hosen.resume.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.FABStyle
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.bps
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.w3c.dom.events.Event

@Composable
fun AutoScrollFAB() {
    var showButton by remember { mutableStateOf(false) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            showButton = window.scrollY > 300
        }
        window.addEventListener("scroll", listener)
        onDispose {
            window.removeEventListener("scroll", listener)
        }
    }

    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .bottom(32.px)
            .right(32.px)
    ) {
        Button(
            onClick = { window.scrollTo(0.0, 0.0) },
            modifier = FABStyle.toModifier()
                .borderRadius(50.px)
                .width(50.px)
                .height(50.px)
                .backgroundColor(Theme.onBackgroundColor)
                .transition(Transition.of("transform", .4.s))
                .transform { translateY(if (showButton) 0.px else 100.px) }
                .opacity(if (showButton) 1.0 else 0.0),
        ) {
            SpanText(
                "↑",
                modifier = Modifier.fontSize(24.bps()).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.backgroundColor)
            )
        }
    }
}
